import { ActionIcon, Tooltip } from '@mantine/core';
import { TiPin, TiPinOutline } from 'react-icons/ti';
import { AutomationStep } from '@/types/automationSteps.ts';
import { usePinnedOutput } from '@/hooks/usePinnedOutput.ts';

type Props = {
  step: AutomationStep;
  outputId?: string | null;
};

const OutputPinButton = ({ step, outputId }: Props) => {
  const { isPinnedOutput, togglePinnedOutput } = usePinnedOutput(step, outputId);

  return (
    <Tooltip label={isPinnedOutput ? 'Un-pin output' : 'Pin output'} openDelay={250}>
      <ActionIcon
        variant="subtle"
        color="gray"
        size="sm"
        onClick={togglePinnedOutput}
        aria-label={isPinnedOutput ? 'Un-pin output' : 'Pin output'}
      >
        {isPinnedOutput ? (
          <TiPin color="black" />
        ) : (
          <TiPinOutline color="black" style={{ strokeWidth: 0 }} />
        )}
      </ActionIcon>
    </Tooltip>
  );
};

export default OutputPinButton;
